<div class="mat-elevation">
  <div class="header-wrapper">
    <span class="mat-h2">{{ title }}</span>
  </div>
  <div>
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" style="padding-left: 8px">
      <!-- This is the tree node template for leaf nodes -->
      <mat-tree-node *matTreeNodeDef="let node">
        <li class="mat-tree-node" matTreeNodeToggle>
          <span class="editing-group-tree-wrapper">
            <button (click)="setCategoryID(node.id)" class="not-button">
              @if (node.id===categoryControl) {
                <span class="bold">{{ node.name }}</span>
              }
              @if (node.id!==categoryControl) {
                <span>{{ node.name }}</span>
              }
            </button>
            @if (node.isDach) {
              <span class="tree-dach">DACH</span>
            }
            @if (node.isWordField) {
              <span class="tree-wordfield">WF</span>
            }
            @if (displayEditingTools) {
              <span class="editing-group-tree">
                <button (click)="editCategory(node.id)" class="edit-button-tree" color="primary" mat-icon-button
                  title="edit-button">
                  <mat-icon class="edit-icon-tree">edit</mat-icon>
                </button>
                <button (click)="deleteCategory(node)" class="edit-button-tree" color="warn" mat-icon-button
                  title="delete-button">
                  <mat-icon class="edit-icon-tree">delete</mat-icon>
                </button>
              </span>
            }
          </span>
        </li>
      </mat-tree-node>
      <!-- This is the tree node template for expandable nodes -->
      <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
        <div class="mat-tree-node">
          <button [attr.aria-label]="'toggle ' + node.name" mat-icon-button matTreeNodeToggle class="small-icon-button">
            <mat-icon>
              {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
            </mat-icon>
          </button>
          <span class="editing-group-tree-wrapper">
            <button (click)="setCategoryID(node.id)" class="not-button">
              @if (node.id===categoryControl) {
                <span class="bold underline">{{ node.name }}</span>
              }
              @if (node.id!==categoryControl) {
                <span>{{ node.name }}</span>
              }
            </button>
            @if (node.isDach) {
              <span class="tree-dach">DACH</span>
            }
            @if (node.isWordField) {
              <span class="tree-wordfield">WF</span>
            }
            @if (displayEditingTools) {
              <span class="editing-group-tree">
                <button
                  (click)="editCategory(node.id)"
                  class="edit-button-tree"
                  color="primary"
                  mat-icon-button
                  matTooltip="Thema bearbeiten"
                  matTooltipShowDelay="1000"
                  matTooltipPosition="left"
                  matTooltipHideDelay="200">
                  <mat-icon class="edit-icon-tree">edit</mat-icon>
                </button>
                <button
                  (click)="deleteCategory(node)"
                  class="edit-button-tree"
                  color="warn"
                  mat-icon-button
                  matTooltip="Thema löschen"
                  matTooltipShowDelay="1000"
                  matTooltipPosition="right"
                  matTooltipHideDelay="200">
                  <mat-icon class="edit-icon-tree">delete</mat-icon>
                </button>
              </span>
            }
          </span>
        </div>
        @if (treeControl.isExpanded(node)) {
          <ul class="sub-tree-wrapper">
            <ng-container matTreeNodeOutlet></ng-container>
          </ul>
        }
      </mat-nested-tree-node>
    </mat-tree>
    @if (dataSource.data?.length < 1) {
      <div class="row-content center-content header-wrapper pad16">
        <mat-spinner></mat-spinner>
      </div>
    }
  </div>
</div>
